import { type WaitForReplyData } from '@/proto/logiblocks/logiblocks';

/** Default wait: 30 seconds. */
export const DEFAULT_WAIT_FOR_REPLY: WaitForReplyData = {
  wait_seconds: 30,
};
